export const getBlocks = (
  dispatch: any,
  dateRange: any[],
  querySize: number,
  maxResults: number,
  update: boolean
) =>
  dispatch({
    type: "GET_BLOCKS",
    dateRange,
    querySize,
    maxResults,
    update,
  });

export const getBlocksSuccess = (data: any[]) => ({
  type: "GET_BLOCKS_SUCCESS",
  data,
});

export const getBlocksFailure = (error: Error) => ({
  type: "GET_BLOCKS_FAILURE",
  error,
});
